import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  agencyDashboard,
  agencyProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import AgencyDashboardNewRequirementsFirstTime from "./AgencyDashboardNewRequirementsFirstTime";
import AgencyDashboardNewRequirements from "./AgencyDashboardNewRequirements";
import AgencyDashboardBookmarked from "./AgencyDashboardBookmarked";
import AgencyDashboardContacted from "./AgencyDashboardContacted";

export default function AgencyDashboard() {
  const [values, setValues] = useState({
    isEmptyNewRequirement: true,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleOnSelect = (val) => {
    // activeAgencyDashboardTabIndex
    localStorage.setItem("activeAgencyDashboardTabIndex", val);
  };

  const handleOnClickDoItLater = () => {
    setValues({
      isEmptyNewRequirement: false,
    });
  };

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={agencyDashboard}
        profileLink={agencyProfile}
        activeLink={activeLinkDashboard}
      />
      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <h1 className="mt-dashboard-title">Dashboard</h1>
        </div>
        <div className="mt-platform-tabs">
          <Tabs
            defaultIndex={parseInt(
              localStorage.getItem("activeAgencyDashboardTabIndex")
            )}
            onSelect={handleOnSelect}
          >
            <TabList>
              <Tab>New Requirements</Tab>
              <Tab>Contacted</Tab>
              <Tab>Bookmarked</Tab>
            </TabList>
            <TabPanel>
              {values.isEmptyNewRequirement ? (
                <AgencyDashboardNewRequirementsFirstTime
                  handleOnClickDoItLater={handleOnClickDoItLater}
                />
              ) : (
                <AgencyDashboardNewRequirements />
              )}
            </TabPanel>
            <TabPanel>
              <AgencyDashboardContacted />
            </TabPanel>
            <TabPanel>
              <AgencyDashboardBookmarked />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
